import React from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { SchoolFillIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { ChevronDownIcon } from '@/icons';
import { useIsSmallerThanTabletSm } from '@/module/public/hooks/useIsSmallerThanTabletSm';
import { getSafeSchoolNameTKey } from '@/shared/category/getSafeSchoolNameTKey';
import { SelectedDropDownMenu } from '@/shared/quizList/DropdownSchool/SelectedDropDownMenu';
import { cn } from '@/utils';
export const DropdownSchool = (props: {
  schoolTypes: {
    name: string;
    value: string;
  }[];
  selectedSchoolTypeName: string;
  onSelectedSchoolType: (value: string) => void;
  variant?: 'underline' | 'titlePill';
  forceTitlePillOnMobile?: boolean;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    schoolTypes,
    selectedSchoolTypeName,
    onSelectedSchoolType,
    variant = 'underline',
    forceTitlePillOnMobile = false
  } = props;
  const isSmallerThanTabletSm = useIsSmallerThanTabletSm();
  const isTitlePill = variant === 'titlePill' && (!isSmallerThanTabletSm || forceTitlePillOnMobile);
  const isForcedMobileTitlePill = isTitlePill && isSmallerThanTabletSm && forceTitlePillOnMobile;
  const triggerClassName = cn(isTitlePill && 'gap-xs rounded-sm border-2 border-opacity-assistive bg-strong-alternative px-md py-xs text-strong hover:bg-violet-100 hover:text-strong data-[state=open]:bg-violet-100', !isTitlePill && isSmallerThanTabletSm && 'text-default', !isTitlePill && !isSmallerThanTabletSm && 'border-b-2 border-b-strong text-strong hover:text-violet-400');
  const getSchoolNameLocalize = (_schoolType?: string) => {
    return t(getSafeSchoolNameTKey(_schoolType));
  };
  const selectedSchoolLabel = getSchoolNameLocalize(selectedSchoolTypeName);
  return <SelectedDropDownMenu contentProps={{
    align: 'start'
  }} className={cn(isTitlePill ? cn('min-w-0 max-w-full overflow-hidden', isForcedMobileTitlePill ? 'text-heading-md-bold' : 'text-heading-lg-extrabold') : 'text-heading-xl-extrabold', triggerClassName)} menu={schoolTypes.map(s => ({
    name: getSchoolNameLocalize(s.name),
    value: s.value
  }))} selectedLabel={<>
          {!isSmallerThanTabletSm && !isTitlePill && <SchoolFillIcon fill={ICON_COLOR.strong} size={'md'} />}
          <span className="min-w-0 truncate">{selectedSchoolLabel}</span>
          <ChevronDownIcon className="shrink-0" />
        </>} selectedValue={selectedSchoolTypeName ? selectedSchoolTypeName : 'ALL'} onSelectedMenu={onSelectedSchoolType} data-sentry-element="SelectedDropDownMenu" data-sentry-component="DropdownSchool" data-sentry-source-file="DropdownSchool.tsx" />;
};